import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Alert from '../../../Alert/Alert';
import Container from '../../../Container/Container';

import {
  TXTWCL_Complete_your_profile_or_make__ELL,
  TXTWCL_Final_Steps,
  TXTWCL_N0_steps_left,
  TXTWCL_Verify_your_ID_within_30_days__ELL,
  TXTWCL_YouXre_all_set,
  TXTWCL_Your_account_has_been_createdX_1,
  TXTWCL__Complete_your_profile_
} from './RMFCompleted.messages.json';
import { alert, contentContainer, header, secondaryText } from './RMFCompleted.scss';
import { Deposit } from './components/Deposit/Deposit';
import { VerifyAccount } from './components/VerifyAccount/VerifyAccount';

const RMFCompleted: React.FC = () => (
  <Container
    page={RMFCompleted}
    headerProps={{
      title: <Translation {...TXTWCL_Final_Steps} />,
      buttons: {}
    }}
    pageTopTitle={<Translation {...TXTWCL_YouXre_all_set} />}
    pageTopSubtitle={
      <>
        <Translation {...TXTWCL_Your_account_has_been_createdX_1} />{' '}
        <Translation {...TXTWCL_Complete_your_profile_or_make__ELL} />
      </>
    }
  >
    <div>
      <div className={alert}>
        <Alert variant="info">
          <Translation {...TXTWCL_Verify_your_ID_within_30_days__ELL} />
        </Alert>
      </div>

      <div className={contentContainer}>
        <div className={header}>
          <strong>
            <Translation {...TXTWCL__Complete_your_profile_} />
          </strong>
          <h3 className={secondaryText}>
            <Translation {...TXTWCL_N0_steps_left} values={{ 0: 2 }} />
          </h3>
        </div>
        <VerifyAccount />
        <Deposit />
      </div>
    </div>
  </Container>
);

RMFCompleted.displayName = 'RMFCompleted';

export default RMFCompleted;
